<template>
  <v-content>
    <v-divider></v-divider>
    <!--TODO footer显示逻辑需要优化-->
    <l-fixed-window
      :offset-top.sync="offsetTop"
      :to-bottom="$route.meta.showFooter ? 36: 0"
      ref="fixedWindow"
    >
      <template slot="fixed-top">
        <v-progress-linear class="py-0 my-0" height="2" indeterminate v-if="pageLoading"></v-progress-linear>
        <div :class="floatingTabs ? 'elevation-1':''" class="top-container transition-200">
          <!--<main-tabs style="position: relative; z-index: 2" v-show="!isWxLogin"></main-tabs>-->
          <LRouterTabs style="position: relative; z-index: 2" v-show="!isWxLogin"></LRouterTabs>
          <main-breadcrumbs
            style="position: relative; z-index: 1;"
            v-if="$L.cfg.clipped"
            v-show="!isWxLogin"
          ></main-breadcrumbs>
          <!--<v-divider v-if="$L.cfg.clipped"></v-divider>-->
        </div>
      </template>
      <!--{{$L.tab.toList}}-->
      <l-slide-y-enter-transition>
        <DynamicRouterView :include="$L.tab.toList">
          <router-view :key="keyFilter($route)"/>
        </DynamicRouterView>
      </l-slide-y-enter-transition>
    </l-fixed-window>
  </v-content>
</template>

<script>
import LFixedWindow from '../../LFixedWindow/LFixedWindow'
import MainBreadcrumbs from '../LBreadcrumbs/mainBreadcrumbs'
import LSlideYEnterTransition from '../../LSlideYEnterTransition/LSlideYEnterTransition'
import {Tab} from '../LRouterTabs/RouterTab'
import {createHelpers} from 'vuex-map-fields'
import LRouterTabs from '../LRouterTabs'
import DynamicRouterView from '@/ladmin/components/LMain/LContent/DynamicRouterView.js'

const {mapFields} = createHelpers({
  getterType: '$L/getField',
  mutationType: '$L/updateField',
})
export default {
  name: 'LContent',
  components: {DynamicRouterView, LSlideYEnterTransition, MainBreadcrumbs, LRouterTabs, LFixedWindow},
  data: () => ({
    offsetTop: 0,
  }),
  computed: {
    ...mapFields([
      'dark',
      'floatingTabs',
      'pageLoading',
      'replaceTabNext',
    ]),
    isWxLogin () {
      return !(sessionStorage.getItem('isWxLogin') === null)
    },
  },
  watch: {
    offsetTop (val, oldVal) {
      if (val && !oldVal) {
        this.floatingTabs = true
      }
      if (!val && oldVal) {
        this.floatingTabs = false
      }
    },
    '$route' (to, from) {
      // console.log('key = ', this.keyFilter(this.$route))
      this.$refs.fixedWindow.refresh()
      let root
      try {
        root = to.matched[0].components.default
        if (root.name !== this.$L.opts.MAIN_COMPONENT_NAME) return
      } catch (e) {
      }

      let tab = Tab.fromRoute(to)
      if (this.$L.tab.currentTab && this.$L.tab.currentTab.tid === tab.tid) {
        // 等于当前tab，不用跳转
      }
      else {
        if (this.replaceTabNext) {
          // console.log('replace tab', tab)
          this.$L.tab.replace(tab)
          this.replaceTabNext = false
        }
        else {
          this.$L.tab.push(tab)
        }
      }
    },
  },
  methods: {
    keyFilter (route) {
      return route.fullPath
    },
  },
}
</script>

<style scoped>

</style>
